<template>
  <!-- One empty state for every list. variant "simple": icon in a soft purple circle, title, hint.
       variant "card": dashed light-purple box with a stacked-cards illustration, title, hint and the slot (an action). -->
  <div v-if="variant === 'card'" class="flex items-center justify-center py-[16px] px-[8px] font-roboto" :class="minHeight">
    <div class="w-full max-w-[360px] flex flex-col items-center text-center gap-[6px] px-[16px] py-[20px] rounded-[12px] border-[1.5px] border-dashed border-[#D9D4F5] bg-[#FAF9FF]">
      <span class="relative w-[64px] h-[54px]">
        <!-- back card, front card with lines, magnifier badge -->
        <span class="absolute left-[12px] top-[2px] w-[40px] h-[48px] rounded-[8px] bg-[#E9E5FB] rotate-[-8deg]" />
        <span class="absolute left-[10px] top-[5px] w-[40px] h-[48px] rounded-[8px] bg-[#fff] border border-[#E1DCF8] shadow-[0px_4px_12px_0px_#8479E11F] flex flex-col gap-[5px] px-[7px] pt-[10px]">
          <span class="h-[4px] w-[70%] rounded-full bg-[#E9E5FB]" />
          <span class="h-[4px] w-full rounded-full bg-[#F1EFFC]" />
          <span class="h-[4px] w-[55%] rounded-full bg-[#F1EFFC]" />
        </span>
        <span class="absolute right-[2px] bottom-[2px] w-[24px] h-[24px] rounded-full bg-[#8479E1] flex items-center justify-center shadow-[0px_4px_10px_0px_#8479E166]">
          <svg v-if="icon === 'search'" width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="11" cy="11" r="6.5" stroke="#fff" stroke-width="2.2" />
            <path d="M16 16l4 4" stroke="#fff" stroke-width="2.2" stroke-linecap="round" />
          </svg>
          <svg v-else width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M5 12h14M12 5v14" stroke="#fff" stroke-width="2.2" stroke-linecap="round" />
          </svg>
        </span>
      </span>
      <p class="m-0 mt-[4px] text-[14px] laptop:text-[15px] font-semibold text-[#333333]">{{ title }}</p>
      <p v-if="text" class="m-0 max-w-[300px] text-[12px] laptop:text-[13px] leading-[18px] text-[#8A9099]">{{ text }}</p>
      <slot />
    </div>
  </div>

  <div v-else class="flex flex-col items-center justify-center text-center gap-[6px] laptop:gap-[10px] py-[24px] laptop:py-[40px] px-[16px] font-roboto" :class="minHeight">
    <span class="w-[52px] h-[52px] laptop:w-[84px] laptop:h-[84px] rounded-full flex items-center justify-center bg-[#F1EFFC]">
      <svg v-if="icon === 'search'" class="w-[24px] h-[24px] laptop:w-[34px] laptop:h-[34px]" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="6.5" stroke="#8479E1" stroke-width="1.8" />
        <path d="M16 16l4 4" stroke="#8479E1" stroke-width="1.8" stroke-linecap="round" />
      </svg>
      <svg v-else class="w-[24px] h-[24px] laptop:w-[34px] laptop:h-[34px]" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M7 3h7l4 4v14H7V3z" stroke="#8479E1" stroke-width="1.8" stroke-linejoin="round" />
        <path d="M14 3v4h4M10 12h5M10 16h5" stroke="#8479E1" stroke-width="1.8" stroke-linecap="round" />
      </svg>
    </span>
    <p class="m-0 text-[14px] laptop:text-[18px] font-semibold text-[#333333]">{{ title }}</p>
    <p v-if="text" class="m-0 max-w-[360px] text-[12px] laptop:text-[14px] leading-[18px] laptop:leading-[20px] text-[#8A9099]">{{ text }}</p>
    <slot />
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    title: { type: String, default: "No records found" },
    text: { type: String, default: "There's nothing to show here yet." },
    // "list" (document) or "search" (magnifier)
    icon: { type: String, default: "list" },
    // "simple" or "card"
    variant: { type: String, default: "simple" },
    minHeight: { type: String, default: "min-h-[30vh]" },
  },
};
</script>
